import { api } from ".";

export const deleteBatchRequest = async (
    uid: string
    ): Promise<string> => {
  await api.post<void>(
    `batch/delete-batch/${uid}`,
  );
  return `Lote ${uid} excluído com sucesso`;
};